<template>
  <div class="outer-container">
    <div class="film-detail-container">
      <div class="film-detail" v-if="film">
        <img :src="getSvgPath()" alt="Film Category" class="film-detail-top">
        <img :src="film.image" :alt="film.title" @error="imageError" class="film-image">
        <p class="title" v-html="formattedText(film.title)"></p>
        <p class="data" v-html="formattedText(film.data)"></p>
        <p class="content" v-html="formattedText(film.content)"></p>
        <p class="content" v-if="film.content2" v-html="formattedText(film.content2)"></p>
        <p class="refer-text" v-if="film.content3" v-html="formattedText(film.content3)"></p>
        <p class="credit" v-html="formattedText(film.credit)"></p>
      </div>
    </div>

    <div class="close-button-container">
      <img :src="require('../assets/SVG/X-WHITE.svg')" alt="Close" @click="closePage">
    </div>

  </div>
</template>

<script>
export default {
  name: 'FilmDetail',
  data() {
    return {
      film: null,
      loading: false,
      error: null
    };
  },
  async created() {
    try {
      this.loading = true;
      const filmId = this.$route.params.id;
      this.film = await this.fetchFilmDetailFromAPI(filmId);
    } catch (err) {
      this.error = 'An error occurred while fetching film details.';
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowHeight);
      this.getWindowHeight();
    })
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.getWindowHeight);
  },
  methods: {
    getWindowHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
  
    async fetchFilmDetailFromAPI(id) {
      const filmsDetails = {
        1: {
          title: '熊になる',
          image: require('@/assets/film_01.jpg'),
          data: '2008  ／ DV  ／ Color  ／ 4:3  ／ Stereo  ／ 47min.',
          content: '初監督作品。熊の着ぐるみを着て働く無表情な男の逃避行。東京の高円寺駅前から始まり、千葉県南房総の港町、そして埼玉県入間川河畔まで断続的に撮影された。',
          credit: '●出演：本間裕人／小野まりえ／實川阿季／<br class="norm_br_b">メクダシ カリル／川瀬陽太／でんべー／鈴木麻衣花／<br class="norm_br_b">青木友里／<br class="norm_br_c">岩崎一則(Hi-Hi)／岸学(どきどきキャンプ)／<br class="norm_br_b">佐藤満春(どきどきキャンプ)／太田敦／<br class="norm_br_c">角雄介(JDB)／<br class="norm_br_b">竹澤譲／吉野雄大／山本泉一／大塚信一\n●制作：本間裕人／吉野雄大\n●撮影・照明：飯岡聖英\n●録音協力：小林徹哉\n●協力：竹澤譲／高橋雄三／広瀬幸一／佐々木耕太／<br class="norm_br_b">古川裕己／大塚信一／山本泉一／本藤美和\n●劇用車：月光堂\n●制作協力：ATOMIC FILM\n●ロケ協力：福寿園／春日部フジバッティングセンター\n●プロダクション協力：グリスト／稲川素子事務所／<br class="norm_br_b">ケイダッシュステージ／グッドラックカンパニー\n●監督・脚本・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=YuALX7FS31I" class="white-link">予告編</a>\n',
          link: 'FeatureFilm'

        },
        2: {
          title: 'みずち',
          image: require('@/assets/film_02.jpg'),
          data: '2013  ／ HD  ／ Color  ／ American Vista  ／ Stereo  ／ 65min.',
          content: 'みずち、古くは「みつち」。「水の霊的な力・存在」の意。八岐大蛇に代表される日本の水神。水に住み、蛇に似て人を害するという想像上の動物。ダムに沈んだ村、過去との因縁に挑む男二人と女一人。東日本大震災の衝撃から本作の制作を決意。翌2012年、真夏の房総半島を舞台にオールロケーションによって撮影された。',
          credit: '●出演：川瀬陽太／堀江実／汐見ゆかり／川瀬友貴／<br class="norm_br_b">山本泉一／吉田アミ\n●撮影・照明：飯岡聖英　●録音：小林徹哉\n●整音・効果：臼井勝　●整音助手：有馬美保\n●音楽：吉田アミ／大谷能生\n●編集：川瀬友貴　●助監督：川瀬友貴／堀修生\n●ヘアメイク：宮下くみこ　●ケイタリング：青木しほ\n●脚本協力：大塚信一　●タイトルデザイン：本間裕人\n●フライヤーデザイン：nu　●WEBサイト制作：山ノ内智雄\n●スペシャルサンクス：渕辺弘一／窪田りえ／<br class="norm_br_b">臼井たか子／吉野雄大／羽辺恭介\n●プロダクション協力：株式会社ディケイド　<br class="norm_br_b">●ロケーション協力：南房総市\n●製作：本間プロダクション\n●監督・脚本・製作：堀江実\n\n<a href="https://www.youtube.com/watch?v=zm3XfU9QD2k" class="white-link">予告編</a>\n',
          link: 'FeatureFilm'
        },

        3: {
          title: '首くくり栲象の庭',
          image: require('@/assets/film_03.jpg'),
          data: '2016  ／ HD  ／ B&W  ／ Standard  ／ Stereo  ／ 74min.',
          content: '東京の西のはずれ、まもなく古希を迎えようとしている男は、自宅の庭で毎日首を吊っている。1960年代後半より路上で活動をはじめた男は、半世紀生きたことを契機に、チェーホフのワーニャ伯父に自身を重ねながら、日々の営みとして自宅の庭で首を吊り始めた。それから20年近くものあいだ、毎日のように男は首を吊ってきたのだった…。2014年末より1年以上に渡って撮影。被写体との関係から、個人映画のスタイルを初めて採用した。',
          credit: '●出演：首くくり栲象／市川淳一／秋山珠羽沙\n●音楽：藤田陽介\n●衣装 for TABASA：加藤哲朗(Ka na ta)\n●撮影協力：土田拓生　●編集協力：川瀬友貴\n●主題歌 「下天」<br class="norm_br_b">作詞・作曲・編曲：藤田陽介　<br class="norm_br_b">唄：藤田陽介／秋山珠羽沙\n●宣伝美術：nu　●WEBサイト制作：山ノ内智雄\n●スペシャルサンクス：黒沢美香＆ダンサーズ／秋山夏葉／<br class="norm_br_b">ロコ・サトシ／いしわためぐみ\n●監督・製作・撮影・編集：堀江実\n\n<a href="https://www.minoruhorie.com/takuzo/" class="white-link">公式HP</a>　　<a href="https://www.youtube.com/watch?v=TuL2Vi0AC-g" class="white-link">特報</a>　　<a href="https://www.youtube.com/watch?v=roeoWD4FHz0" class="white-link">予告編</a>\n',
          link: 'FeatureFilm'
        },

        4: {
          title: '黒沢美香＆ダンサーズ<br class="norm_br_b"> 稽古ドキュメント2017',
          image: require('@/assets/film_04.jpg'),
          data: '2018 ／ HD ／ Color ／ 16:9 ／ Stereo ／ 281min.',

          content: '日本のコンテンポラリーダンスのパイオニア・黒沢美香の追悼公演の稽古に密着。5ヶ月に渡って計48回の稽古に参加、200時間を越える撮影素材から紡がれた前後篇5時間に迫る大作。黒沢美香による振付が、新たなダンサー達へと受け継がれていく怒涛の稽古風景。総勢28名、黒沢美香＆ダンサーズとしての最後の身体。',
          content2: '＊　　 　＊ 　　　＊',
          content3: '<div class="content3-paragraph">昨年12月17日、夜明け前の綱島に私はいた。鶴見川の河川敷に三脚を据えてキャメラのファインダーを覗いていた。何もうつっていなかった。肉眼で見える深い闇のグラデーションは、フレームによって無慈悲に切り取られた世界では、黒一色に潰れて身も蓋もない虚しさしかない。ゆっくりとカメラを動かしてみた。なぜそうするのかもわからずにそうしていた。何がここにあるのか、なにを写すのか、なにを期待していたのか、今となってはもうわからない。ここにいなければならないわけではなかった。ここにいたいわけでもなかった。ただ、ここにいることを許されているような気はしていた。太陽があらわれ、世界があいさつをはじめた頃には、これでいいという不思議な充実感が私の身体に満ちていた。撮影がおわった。</div><div class="content3-paragraph">そのとき掴み取った澄明な光と空気とともに、手元にあった稽古場の記録映像（私の撮影でない）によって掌編を拵えた。そのとても小さな玉のような感傷的な作品によって、そのひとの不在を自分自身に納得させた。今見返すと、それは、未来の私自身へ向けた手紙であった。</div><div class="content3-paragraph">先日通過した企画のひとつ、追悼上映会の映像編集を任され、ダンサーズとの濃密なやり取りのさなか、夏も終わる頃に私はとつぜんに鶴見川の土手を駆けおりた。導かれながらも、確固たる意志を抱いて、駆けおりたそのままの勢いで稽古場に足を踏み入れた。無心の塊となってゴロゴロと全力で転がり込んだのだった。覚悟はすでに決まっていた。</div><div class="content3-paragraph">それから数ヶ月、じっと凝固したまま私は踊る人びとを見つめている。愚直に稽古を重ね、幾度も踊ることによって、そのひとと出会い直し、自らの身体と出会い直し、自分自身とも出会い直していく。身体の奥に仕込まれた振付を発掘した冒険者たちは、その枷としての振付を、いまこの瞬間の身体によって鮮やかに裏切っていく。そして本番の舞台上には、艶やかな逞しい身体たちが痛快に躍動する豊穣な時間と空間がきっと立ち上がるだろう。</div><div class="content3-paragraph">沈黙を保ち、ただひたすら祈るような気持ちで私は、踊るひとたちの傍らにそっと在りたいとおもっている。踊り手のひとりが、まるでずっとここに住んでるみたいだねと笑って言う。そう、私はいわば綱島の座敷わらしであった。</div><div class="content3-paragraph">「綱島の座敷わらし」<span class="ref_auth">text:</span> 堀江 実\n（黒沢美香追悼企画「美香さんありがとう」ブログ2017年12月17日掲載）</div>',
          credit: '●出演：黒沢美香＆ダンサーズ\n磯島未来／糸山明子／大川あじさい／大崎晃伸／<br class="norm_br_b">恩田香／川山洋／公門美佳／<br class="norm_br_c">小檜朱実／小島晴子／<br class="norm_br_b">小林美沙緒／斎藤麻里子／椎名利恵子／さそうすなお／<br class="norm_br_b">滝口美也子／多田慶子／<br class="norm_br_c">戸川悠野／長野れいこ／新美佳恵／<br class="norm_br_b">福山孝子／藤井友美／堀江進司／松之木天辺／<br class="norm_br_b">南呼子／<br class="norm_br_c">山野邉明香／吉川恵子／<br class="norm_br_b">吉田法子／リナ・リッチ／ワカバヤシマサノリ\n●振付：黒沢美香\n●Special Thanks：スタジオクロちゃん／\n平松み紀／加藤若菜／河内崇／三枝淳／サエグサユキオ／<br class="norm_br_b">萩野緑／<br class="norm_br_c">武藤浩史／前野隆司／クリタチカコ／<br class="norm_br_b">吉福敦子／宇佐美とよみ／金子典子／<br class="norm_br_c"><br class="norm_br_b">吉田由紀子／平岡久美／近正文子／首くくり栲象\n●監督・撮影・編集：堀江実\n\n',
          link: 'FeatureFilm'
        },

        5: {
          title: 'Ｋと流刑地',
          image: require('@/assets/film_05.jpg'),
          data: '2019  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 89min.',
          content: '1973年11月、前衛芸術家・風倉匠は、北海道の網走へと移住し、フランツ・カフカの小説『流刑地にて』の映画化を試みる。二年半続けたものの、ついに完成することはなかった…。首くくり栲象の師であり、日本のハプニング・アーティストの先駆者でもあった風倉匠が、なぜこの時代に映画を作ろうとしたのか、そして、なぜ完成させることができなかったのか。当時を知る者たちへのインタビューや、数多のテキストを頼りに、彼の思考と実像、そして戦後史をめぐる旅が、2018年3月、首くくり栲象の死とともにはじまる。',
          credit: '●インタビュー出演：菅章／大井恒行／鈴木一民／遠藤昭\n●インタビュー撮影：川瀬友貴　●風景撮影：堀江実\n●音楽：クリストフ・シャルル\n●協力：黒ダライ児／福住治夫／ユキノ恭弘／渕野孝\n●撮影協力：大分市美術館／東京文化財研究所\nスペシャルサンクス：橋本俊子／首くくり栲象\n監督・製作・編集：堀江実\n\n参考テキスト：堀江実『3人の「K」と流刑地へ』（『あいだ 245号』 2019年1月20日発行）',
          link: 'FeatureFilm'
        },

        6: {
          title: 'The Making of サマースプリング',
          image: require('@/assets/film_06.jpg'),
          data: '2019  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 134min.',
          content: '即興演奏家・吉田アミの自伝的小説『サマースプリング』の舞台化を追ったドキュメンタリー作品。平成元年、中学一年生の少女が体験した「地獄」に対し、2019年現在からその場に相応しい光と音、嘘のない言葉と身体を探る。平成の終わり、死闘の記録。',
          credit: '●出演：吉田アミ／立川貴一／大谷能生\n●原作：吉田アミ「サマースプリング」（太田出版）\n●音楽：大谷能生／吉田隆一\n●写真：三野新　●TikTok動画：ふぁーろん\n●協力：土屋光／前澤秀登／YukoNexus6／榎本櫻湖／<br class="norm_br_b">五所純子／<br class="norm_br_c">木村カナ／郡淳一郎／<br class="norm_br_b">三宅里沙／細馬宏通／増井彩／星葡萄\n●撮影協力：SCOOL／浅草橋天才算数塾\n●制作：ミニスキュル・シングス\n●監督・撮影・編集：堀江実\n',
          link: 'FeatureFilm'
        },

        7: {
          title: 'やもりの行方',
          image: require('@/assets/film_07.jpg'),
          data: '2022  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 68min.',
          content: '御年91歳の美術家・遠藤昭の精力的な活動に寄り添うコロナ禍の日々。1945年の終戦時、彼は15歳だった。',
          credit: '●出演：遠藤昭\n●協力：矢部優子／広瀬淳二／渡辺隆雄／安藤祐／<br class="norm_br_b">江尻潔／阿部浩／木村由／細田麿臣\n●撮影協力：NO TRUNKS／ギャラリーブロッケン／<br class="norm_br_b">土日画廊／好文画廊／足利市立美術館\n●監督・撮影・編集：堀江実\n',
          link: 'FeatureFilm'
        },

        8: {
          title: 'イバラ・夜の祈り',
          image: require('@/assets/film_08.jpg'),
          data: '2023  ／ 4K+8mm  ／ Color  ／ Standard  ／ Stereo  ／ 65min.',
          content: 'モノローグと風景の結びつきを要としたヤマザキアキラによるオリジナル脚本の映画化であり、約10年ぶりとなる劇映画復帰作。映画を作る男と、その男を支える女。そして二人の間に生まれた一人息子。夢・記憶・現実の三幕構成によって映画表現そのものを問い直す。',
          credit: '●出演：小林エレキ／白波多カミン／米澤成美／石本日悠／<br class="norm_br_b">瀧澤綾音／土田拓生／藤一平<br class="norm_br_a">●プロデューサー：ヨシダシゲル／吉野雄大\n●監督・編集：堀江実　●脚本：ヤマザキアキラ\n●撮影：ヨシダシゲル／堀江実　●撮影助手：髙木美佑　<br class="norm_br_a">●音楽：白波多カミン／テンテンコ\n●録音：横川一　●整音：川本七平　<br class="norm_br_c">●助監督：東響生　<br class="norm_br_b">●スチール：髙木美佑　●タイトル：阿部つよし\n●制作協力：橋野純平／藤村英恵　●衣装協力：堀江進司\n●撮影協力：宮崎幸司／甲斐聖太郎／山本泉一／<br class="norm_br_b">岩本慎史／秋津ねを\n●機材協力：中野貴大／川本七平　<br class="norm_br_b">●ロケーション協力：コクテイル書房／藤岡啓二\n●音楽録音・編曲協力：大谷能生／猪爪東風(ayU tokiO)\n●レコーディングスタジオ：日野音楽室第Ⅲ\n●協力プロダクション：コギトワークス／<br class="norm_br_b">モノサシパブリックリレーションズ\n●企画・制作：プラネットナインピクチャーズ\n\n<a href="https://minoruhorie.com/ibara/" class="white-link">公式HP</a>　　<a href="https://www.youtube.com/watch?v=0AdcdXH5x2k" class="white-link">特報</a>　　<a href="https://www.youtube.com/watch?v=6rzGMHY3cSE" class="white-link">本予告</a>　　<a href="https://www.youtube.com/watch?v=_LvOJZ6qXwo" class="white-link">主題歌MV</a>\n',
          link: 'FeatureFilm'
        },
//  
//
// SHORT FILMS DETAIL No.101 -
//
//
        101: {
          title: '短編シリーズ「cinemole」 全6話',
          image: require('@/assets/shortfilm_01.jpg'),
          data: '2012  ／ HD  ／ Color  ／ 16:9  ／ Stereo',
          content: '都内の地下鉄と名画座を巡り歩く映画モグラ。俳優・川瀬陽太との共同作品。',
          credit: '●出演・音楽・構成：川瀬陽太\n●製作：ad-lab\n●撮影・編集：堀江実\n',
          link: 'ShortFilm'
        },
        102: {
          title: '「カミュなんて知らない」<br class="norm_br_b">上映前コメント映像',
          image: require('@/assets/shortfilm_02.jpg'),
          data: '2015  ／ HD  ／ Color  ／ American Vista  ／ Stereo  ／ 4min.',
          content: '2015年5・6月、フランスのパリ日本文化会館にて、映画『カミュなんて知らない』の上映前に流れた掌編作品。柳町監督宅に飾られていた横山大観『夜桜』のシルクスクリーンとともに、撮影時期にちょうど満開を迎えた井の頭公園、上野公園、千鳥ヶ淵の桜並木も重要な被写体となった。',
          credit: '●出演：柳町光男\n●撮影・編集：川瀬友貴\n●監督：堀江実\n\n<a href="https://www.youtube.com/watch?v=35OuACeWqM0" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },
        103: {
          title: '「追悼特別上映会<br class="norm_br_b"> ダンサー黒沢美香の世界」予告編',
          image: require('@/assets/shortfilm_03.jpg'),
          data: '',
          content: '2017年12月1日・2日にアップリンク渋谷で開催された上映会では、予告編だけでなく、当日上映されるすべての記録映像の編集も担当した。',
          credit: '●撮影・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=rLCJtgzTP_k" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },
        104: {
          title: '「黒沢美香振付作品集<br class="norm_br_b">「ダンス☆ショー」より」予告編',
          image: require('@/assets/shortfilm_04.jpg'),
          data: '',
          content: '「追悼上映会」の予告編とともに、黒沢美香＆ダンサーズの面々と何度も意見交換しながら編集された。最後に流れる歌は、ミカヅキ会議の武藤浩史と前野隆司によるもの。',
          credit: '●撮影・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=_vQnl1yWWQg" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },

        105: {
          title: '「あしたのあたし」天才算数塾Ver.',
          image: require('@/assets/shortfilm_05.jpg'),
          data: '2019  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 32min.',
          content: '2019年2月16日、浅草橋天才算数塾にて開催されたミニスキュル・シングス（立川貴一＋吉田アミ）とYukoNexus6による共同イヴェントをドキュメント。『The Making of サマースプリング』の導入部として撮影されたが、本編には使用されず、独立した短編となった。',
          credit: '●撮影・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=QOgjyItd7gM" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },
        106: {
          title: 'YukoNexus6のお引越し記念Live!',
          image: require('@/assets/shortfilm_06.jpg'),
          data: '2019  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 40min.',
          content: '2019年5月12日、YukoNexus6が主宰した水道橋Ftarriでのライヴの映像記録。吉田アミがハウリング・ヴォイス、立川貴一が照明として参加している。ライヴの主題は「調律」。',
          credit: '●撮影・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=voXB5O126lE" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },
        107: {
          title: '敗戦記念日',
          image: require('@/assets/shortfilm_07.jpg'),
          data: '2019  ／ HD  ／ Color  ／ 16:9  ／ Stereo  ／ 18min.',
          content: '<span class="nowrap_text">「終戦」という一語によって「敗戦」の現実を回避しようとする力学に如何に抗うか。令和元年8月15日にYoutube上にて発表。</span>',
          credit: '●撮影・編集：堀江実\n\n<a href="https://www.youtube.com/watch?v=Ez3-iBSnarE" class="white-link">作品リンク</a>\n',
          link: 'ShortFilm'
        },
        108: {
          title: 'ひとつの海',
          image: require('@/assets/shortfilm_08.jpg'),
          data: '2020  ／ HD  ／ B&W  ／ Standard  ／ Stereo  ／ 20min.',
          content: 'COVID-19パンデミックの渦中も継続されていたダンス稽古の「空間」と、大倉山記念館ギャラリーでの現場リハーサルに流れた「時間」とが撚り合わされる至高のダンスフィルム。',
          credit: '●出演：リナ・リッチ／堀江進司\n●協力：サエグサユキオ／SHIN／ノムラヒハル／<br class="norm_br_b">福留麻里／ロビー☆カマタ\n●制作：他力本願 × G企画\n●監督・撮影・編集：堀江実\n',
          link: 'ShortFilm'
        },
      };

      // idに対応する作品の詳細を返す
      return filmsDetails[id] ? {
        id: id,
        ...filmsDetails[id]
      } : null; // 該当するidがない場合はnullを返す
    },
    imageError(e) {
      e.target.src = require('@/assets/TOP.jpg'); // 
    },
    formattedText(text) {
      // テキスト内の"\n"を"<br>"に置換
      return text.replace(/\n/g, '<br>');
    },
    getSvgPath() {
      // リンク元によってSVGのパスを動的に変更
      return this.film && this.film.link === 'FeatureFilm' ? require('@/assets/SVG/FEATUREFILMS(WHITE).svg') : require('@/assets/SVG/SHORTFILMS(WHITE).svg');
    },
    closePage() {
      window.history.back(); 
    }
  }
};
</script>

<style>

.outer-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  background-color:rgb(34, 30, 31);
  overflow:auto;
  /* border-color: rgb(237, 44, 9);
  border-style: solid;
  border-width: 1px; */
}

.film-detail-container {
  width: 100%;
  margin: 0 auto;
  border: 0;
}

.film-detail {
  width:90%;
  margin: 0 auto;
  margin-bottom: 5vh;
}


.film-image{
  display: block;
  width: 100%;
  max-width: 740px;
  min-width: 220px;
  height: auto;
  margin: 0 auto;
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.film-detail-top {
  display: block;
  width: 30%;
  max-width: 140px;
  height: auto;
  margin: 0 auto;
  margin-top: 10vh;
  margin-bottom: 60px;
}

.title {
  text-align: center;
  font-family: "Zen Kaku Gothic New";
  font-weight: bold;
  font-size:2rem;
  color: white;
  line-height: 1.0;
  margin-top: 4.0rem;
  margin-bottom:0.9rem;
}

.data {
  text-align: center;
  font-family: "Crimson Text";
  font-weight: 600;
  font-style: italic;
  font-size:1rem;
  color: white;
  line-height: 1;
  word-spacing: 1px;
  margin-top:0rem;
  margin-bottom: 2rem;
}

.content {
  display: flex;
  justify-content: center;
  text-align: justify;
  font-family: "Shippori Mincho", serif;
  font-weight: 500;
  font-size:1rem;
  color: white;
  margin: 0 auto;
  margin-bottom: 2rem;
  line-height: 1.75;
  width: 80%;
  max-width: 880px;
  /* border-color: aliceblue;
  border-style: solid;
  border-width: 1px; */
}

.content3-paragraph {
  margin-bottom: 1.35rem;
}

.credit {
  text-align: center;
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-size:0.9rem;
  color: white;
  margin: 0 auto;
  line-height: 1.75;
  margin-bottom: 2vh;
  width: 95%;
  max-width: 1024px;
}

.refer-text{
  text-align: justify;
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 500;
  font-size:1rem;
  color: white;
  margin: 0 auto;
  margin-bottom: 4vh;

  line-height: 1.75;
  width: 80%;
  max-width: 880px;
}
.ref_auth{
  text-align: center;
  font-family: "Crimson Text";
  font-weight: 600;
  font-style: italic;
  font-size:1rem;
  color: white;
}

.nowrap_text{
  white-space: nowrap;
}
.white-link{
  color: rgb(255, 255, 255);/* リンクの色を白に設定 */
}
.white-link:visited {
  color: white;
}

.close-button-container {
  /* PC Display */
  position: fixed;
  top: 7.0vh;
  right: 5.4vw;
  z-index: 1000; 
  width: 30px;
  }

  .center-div {
    display: flex;
    margin-top: 1em;
    margin-bottom: 1em;
    justify-content: center;
    text-align: center;
}
  .no-marker {
    list-style-type: none;
    text-align: left;
    align-self: flex-start;
    width: fit-content;
    font-size: 0.8em;
    display: inline-block;
    margin: 0;
    padding: 0;
}

.refbooks{
  display: inline-block;
  margin: 0;
  padding: 0;
  font-size: 0.8em;
  white-space: nowrap;
}

.cresit-list{
  list-style-type: none;
  text-align: left;
  align-self: flex-start;
  width: fit-content;
  font-size: 1em;
  display: inline-block;
  margin: 0;
  padding: 0;
}

.norm_br_a{
  display: block;
}
.norm_br_b{
  display: none;
}
.norm_br_c{
  display: block;
}

@media screen and (max-width: 800px) {
.nowrap_text{
white-space:normal;
}
}



    
@media screen and (max-width: 480px) {

.norm_br_a{
  display: block;
}
.norm_br_b{
  display: block;
}
.norm_br_c{
  display: none;
}
.nowrap_text{
  white-space:normal;
}

.film-detail-top {
  display: block;
  width: 30%;
  max-width: 140px;
  height: auto;
  margin: 0 auto;
  margin-top: 15vh;
  margin-bottom: 60px;
}
.film-image{
  display: block;
  width: 100%;
  max-width: 740px;
  min-width: 220px;
  height: auto;
  margin: 0 auto;
}
.title {
  text-align: center;
  font-family: "Zen Kaku Gothic New";
  font-weight: bold;
  font-size:1.25rem;
  color: white;
  line-height: 1.3;
  letter-spacing:normal;
  margin-top: 1.3rem;
  margin-bottom: 0.8rem;
}

.data {
  text-align: center;
  font-family: "Crimson Text";
  font-weight: 600;
  font-style: italic;
  font-size:0.80rem;
  color: white;
  margin-top: 0rem;
  margin-bottom: 1.3rem;
}

.content {
  text-align: justify;
  font-family: "Shippori Mincho", serif;
  font-weight: 500;
  font-size:1.0rem;
  color: white;
  margin: 0 auto;
  margin-bottom: 1.8rem;
  line-height: 1.5;
  width: 100%;
}

.refer-text{
  text-align: justify;
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 500;
  font-size:1rem;
  color: white;
  margin: 0 auto;
  margin-bottom: 4vh;
  line-height: 1.75;
  width: 100%;
}

.credit {
  text-align: center;
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-size:0.7rem;
  color: white;
  margin: 0 auto;
  line-height: 1.75;
  margin-bottom: 2vh;
  width: 95%;
  max-width: 1024px;
}

.close-button-container {
  position: fixed;
  top: 4vh;
  right: 10vw;
  z-index: 1000;
  width:30px;
  }

.close-button-container img{
    width:40px;
    height: 40px;
  }
}
</style>
